<template>
  <div class="comment">
    <div class="comment-view-title">
      评论
    </div>

    <!-- 评论 -->
    <div class="comment-box">
      <!-- 评论 -->
      <el-input :readonly='isReview' type="textarea" resize='none' maxlength="500" show-word-limit
        :placeholder="placeHolder" v-model="textarea">
      </el-input>

      <div class="comment-submit-box">

        <div class="comment-rate">
          <el-rate v-model="rating" :colors="['#24ba58','#24ba58','#24ba58']"></el-rate>
        </div>

        <div @click="submitBtn" class="comment-submit">
          提交
        </div>
      </div>

    </div>

    <!-- 评论展示 -->
    <ul class="comment-list">
      <li class="comment-item" v-for="item of reviewData.list" :key="item.id">
        <img class="item-head" src="" alt="">
        <div class="item-content">
          <div class="item-content-top">
            <span class="item-name">{{item.userName}}</span>
            <span class="item-time">{{item.createTime}}</span>
          </div>
          <span class="item-review">
            {{item.content}}
          </span>
          <el-rate disabled :value="item.score" :colors="['#24ba58','#24ba58','#24ba58']"></el-rate>
        </div>
      </li>

      <div class="page-num">
        <PageNum :pageSize='5' @currentChange='currentChangePage' :pageTotal='pageTotal'
          :currentPage1.sync='currentPage' />
      </div>
    </ul>
  </div>
</template>

<script>
import {
  userReview,
  getReview,
  isReviewed,
} from "@/network/resourceRequest/api";
import utils from "@/util/index";
//页码--------------------------------------------
import PageNum from "@/components/common/PageNum";

export default {
  name: "ResourceComment",
  props: {
    currentFileId: {},
  },
  components: {
    PageNum,
  },

  data() {
    return {
      //星级
      rating: 5,
      //评论内容
      textarea: "",
      value: 4.5,
      //评论页面总数
      pageTotal: 0,
      //当前页--------------------------------------------
      currentPage: 1,
      //评论数据--------------------------------------------
      reviewData: {},
      //是否已经评价过--------------------------------------------
      isReview: false,
    };
  },

  created() {
    //查看用户是否评价过--------------------------------------------
    this.checkReview();
    this.initReview(1);
  },

  watch: {
    currentFileId(newFileId) {
      //查看用户是否评价过--------------------------------------------
      this.checkReview();
      this.initReview(1);
    },
  },

  computed: {
    //评语--------------------------------------------
    placeHolder() {
      return this.isReview ? "您已评论过！" : "请您输入内容";
    },
  },

  methods: {
    //检查用户是否评论过--------------------------------------------
    checkReview() {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return;
      isReviewed(this.$route.query.id).then((res) => {
        if (res.data.success) {
          switch (res.data.data) {
            case 0:
              this.isReview = false;
              break;
            case 1:
              this.isReview = true;
              break;
          }
        }
      });
    },
    //初始化评论
    initReview(pageNum) {
      let data = {
        resourceId: this.$route.query.id,
        pageNum: pageNum,
        pageSize: 5,
      };
      this.currentPage = pageNum;
      getReview(data).then((res) => {
        if (res.data.success) {
          this.reviewData = res.data.data;
          this.pageTotal = res.data.data.total;
        }
      });
    },

    //提交评论
    submitBtn() {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (this.isReview) {
        utils.tips("error", "您已评论过！");
      } else {
        if (this.textarea.length >= 5) {
          let data = {
            content: this.textarea,
            resourceId: this.$route.query.id,
            id: this.$route.query.id,
            score: this.rating,

            userId: 0,
            userName: "",
            userType: "",
          };

          userReview(data).then((res) => {
            if (res.data.success) {
              this.rating = 5;
              this.textarea = "";
              this.isReview = true;
              this.initReview(1);
              utils.tips("success", res.data.code);
            }
          });
        } else {
          utils.tips("error", "最少输入5个字符");
        }
      }
    },
    //页码变化--------------------------------------------
    currentChangePage(newPage) {
      this.initReview(newPage);
    },
  },
};
</script>

<style lang='less' scoped>
.comment {
  border-radius: 2px;
  padding-top: 1px;
  width: 960px;
  min-height: 356px;
  padding-bottom: 20px;

  background-color: #fff;

  .comment-view-title {
    position: relative;

    margin: 20px 0;
    padding-left: 24px;

    font-size: 16px;
    font-weight: bold;

    color: #333;

    &::before {
      display: inline-block;

      position: absolute;
      top: 50%;
      left: 0;

      border-radius: 5px;
      width: 4px;
      height: 40px;

      background-color: #24ba58;

      transform: translateY(-20px);

      content: "";
    }
  }

  .comment-box {
    padding: 0 40px;
    height: 100%;

    .comment-submit-box {
      display: flex;

      margin: 10px 0;

      justify-content: space-between;

      /deep/ .el-rate__icon {
        font-size: 30px;
      }

      .comment-submit {
        border-radius: 16px;
        width: 88px;
        height: 32px;

        font-size: 14px;
        font-weight: 400;
        line-height: 32px;
        text-align: center;

        color: rgba(255, 255, 255, 1);
        background: rgba(36, 186, 88, 1);

        cursor: pointer;
      }

      .comment-submit:hover {
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);

        transform: translateY(-1px);
      }
    }

    .el-textarea {
      margin-bottom: 10px;

      /deep/ .el-textarea__inner {
        height: 100px !important;
      }

      /deep/ .el-textarea__inner:focus {
        border-color: #24ba58;
      }

      /deep/ .el-input__count {
        right: 20px;
        bottom: -15px;
        background-color: transparent;
      }
    }
  }

  .comment-list {
    width: 100%;
    height: 100%;
    padding: 0 40px;

    .comment-item {
      width: 100%;
      display: flex;
      margin-top: 20px;

      .item-head {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background-color: skyblue;
        margin-right: 10px;
      }

      .item-content {
        width: 100%;
        flex: 1;
        min-height: 100px;
        display: flex;
        flex-direction: column;

        .item-content-top {
          display: flex;
          justify-content: space-between;

          .item-name {
            font-size: 14px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          }

          .item-time {
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }

        .item-review {
          width: 100%;
          margin: 10px 0;
          display: inline-block;
          word-wrap: break-word;
          white-space: normal;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }

        .el-rate {
          /deep/ .el-rate__icon {
            font-size: 20px;
          }
        }
      }
    }

    .page-num {
      display: flex;

      margin: 20px 0;

      align-items: center;
      justify-content: center;
    }
  }
}
</style>